<template>
  <div class="qrs">
    <template>
      <div :id="`div_qr_${vacancyListId}`">
        <canvas v-show="false" :id="`qr_canvas_${vacancyListId}`" />
      </div>
    </template>

    <div class="qr-blocks">
      <VDivider horizontal class="qr-blocks__divider-horizontal" />

      <div class="qr-blocks__create">
        <div class="qr-create__title">
          {{ $t('createQR') }}
        </div>
        <div class="qr__button" @click="createQrDialog = true">
          <div class="qr__button_wrap">
            <img :src="require('@/assets/img/qr/create/create.svg')" alt="create" />
            <img :src="require('@/assets/img/qr/create/plus.svg')" alt="plus" class="ml-1" />
          </div>
        </div>
      </div>

      <VDivider vertical class="qr-blocks__divider" />

      <div class="qr-blocks__download">
        <div class="qr-download__title">
          {{ $t('download') }}
        </div>
        <div class="qr-download__buttons">
          <div class="qr__button" @click="downloadPng()">
            <div class="qr__button_wrap">
              <img
                :src="require('@/assets/img/qr/create/png.svg')"
                alt="png"
              />
              <img
                class="ml-3 mr-1"
                :src="require('@/assets/img/qr/create/download.svg')"
                alt="download"
              />
              <span>png</span>
            </div>
          </div>
          <div class="qr__button" @click="downloadSvg()">
            <div class="qr__button_wrap">
              <img
                :src="require('@/assets/img/qr/create/svg.svg')"
                alt="svg"
              />
              <img
                class="ml-3 mr-1"
                :src="require('@/assets/img/qr/create/download.svg')"
                alt="download"
              />
              <span>svg</span>
            </div>
          </div>
        </div>
      </div>

      <VDivider horizontal class="qr-blocks__divider-horizontal" />

      <VDivider vertical class="qr-blocks__divider" />

      <div class="vacancy-list-actions">
        <template>
          <div>
            <a :href="url" class="vacancy-list-actions__link">
              <img
                :src="require('@/assets/img/qr/create/show.svg')"
                alt="show"
              />
              {{ $t('show') }}
            </a>
            <RouterLink :to="getUpdateLink(vacancyListId)" class="vacancy-list-actions__link">
              <img
                :src="require('@/assets/img/qr/create/update.svg')"
                alt="update"
              />
              {{ $t('update') }}
            </RouterLink>
            <button class="vacancy-list-actions__link vacancy-list-actions__link" @click="$emit('toggleVacancyListSocialDialog')">
              <img
                :src="require('@/assets/img/qr/create/socialLink.svg')"
                alt="socialLink"
              />
              {{ $t('socialLink') }}
            </button>
          </div>
        </template>
      </div>

      <VDivider vertical class="qr-blocks__divider" />

      <button class="vacancy-list-actions__link vacancy-list-actions__link_delete" @click="$emit('toggleVacancyListDeleteDialog')">
        <img
          :src="require('@/assets/img/qr/create/delete.svg')"
          alt="delete"
        />
        {{ $t('delete') }}
      </button>
    </div>

    <VacancyListQrDialog v-model="createQrDialog" :vacancy-list-id="vacancyListId" :url="url" />
  </div>
</template>

<script>
import { toRefs, ref } from '@vue/composition-api';
import QRCode from 'qrcode';
import VacancyListQrDialog from './VacancyListQrDialog.vue';

export default {
  name: 'VacancyListQrLinks',
  components: {
    VacancyListQrDialog,
  },
  props: {
    vacancyListId: {
      type: Number,
      required: true,
    },
    url: {
      type: String,
      required: true,
    },
  },
  mounted() {
    const canvas = document.getElementById(`qr_canvas_${this.vacancyListId}`);
    QRCode.toCanvas(canvas, this.url, { errorCorrectionLevel: 'H', width: 2000 }, (error) => {
      if (error) console.error(error);
    });
  },
  setup(props, { emit }) {
    const { vacancyListId, url } = toRefs(props);

    const createQrDialog = ref(false);

    function downloadPng() {
      const qrcodeCanvas = document.getElementById(`div_qr_${vacancyListId.value}`)
        .getElementsByTagName('canvas')
        .item(0);
      const dataUrl = qrcodeCanvas.toDataURL('image/png');
      const link = document.createElement('a');
      link.download = 'qrcode.png';
      link.href = dataUrl;
      link.click();
    }

    function downloadSvg() {
      const options = {
        errorCorrectionLevel: 'H',
      };

      let svg;

      QRCode.toString(url.value, options, (err, string) => {
        if (err) throw err;
        svg = string;
      });

      const element = document.createElement('a');
      element.setAttribute('href', `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svg)}`);
      element.setAttribute('download', 'qrcode.svg');
      element.style.display = 'none';
      document.body.appendChild(element);
      element.click();
      document.body.removeChild(element);
    }

    function getUpdateLink(id) {
      return { name: 'qr-detail', params: { id } };
    }

    return {
      downloadPng,
      downloadSvg,
      createQrDialog,
      getUpdateLink,
    };
  },
};
</script>

<style lang="scss" scoped>
.qr {
  &__button {
    border: 1px solid #e0e0e0;
    border-radius: 6px;
    cursor: pointer;
    &_wrap {
      padding: 8px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      @media screen and (max-width: 1060px) {
        padding: 14px;
        justify-content: center;
      }
      span {
        color: #0A82D9;
      }
    }
  }
}
.qr-blocks {
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: space-between;
  font-size: 14px;
  @media screen and (max-width: 1060px) {
    flex-direction: column;
    align-items: flex-start;
  }
  &__make {
    display: flex;
    flex-direction: column;
  }
  &__divider {
    margin: 0 32px;
  }
  &__divider-horizontal {
    display: none;
    @media screen and (max-width: 1060px) {
      display: block;
      width: 100%;
      margin: 20px 0;
    }
  }
  &__create {
    @media screen and (max-width: 1060px) {
      width: 100%;
      .qr__button {
        width: 50%;
      }
    }
  }
  &__download {
    @media screen and (max-width: 1060px) {
      margin-top: 20px;
      width: 100%;
      .qr__button {
        width: 50%;
      }
    }
  }
}
.qr-create {
  &__title {
    margin-bottom: 15px;
  }
}
.qr-download {
  &__title {
    margin-bottom: 15px;
  }
  &__buttons {
    display: flex;
    align-items: center;
    gap: 10px;
  }
}

.vacancy-list-actions {
  &__link {
    display: flex;
    align-items: center;
    font-size: 0.875rem;
    line-height: 1.375;
    color: #0A82D9;
    text-decoration: underline;
    &_delete {
      text-decoration: none;
      @media screen and (max-width: 1060px) {
        margin-top: 20px;
      }
    }
    svg {
      margin-right: 0.375rem;
    }
  }
}

.qrs {
  @media screen and (max-width: 1750px) {
    width: 100%;
    margin-top: 20px;
  }
  @media screen and (max-width: 1060px) {
    margin-top: 0px;
  }
}
</style>

<i18n lang="yml" locale="ru">
download: Скачать QR-код
show: Просмотреть
update: Редактировать
delete: Удалить
socialLink: Ссылка для соцсетей
createQR: Создать макет с QR-кодом
</i18n>
<i18n lang="yml" locale="en">
download: Download QR-code
show: View
update: Edit
delete: Delete
socialLink: Social Link
createQR: Create a layout with a QR code
</i18n>
